import { Pages } from 'modules/navigation/domain/enums/pages';
import useBoards from 'modules/template-editor/ui/hooks/use-boards';
import useTemplates from 'modules/template-editor/ui/hooks/use-templates';
import { useMemo } from 'react';
import { theme } from 'styles/theme/theme';
import { DivProps } from 'typings';
import UDText from 'ud-ui/components/text';
import PopupControl from './popup-control';
import { PanelItemWrapper } from './styles';

/**
 * Табло типа TV — то, что показывают на экране в зале: без джойстика и без переключения
 * табло из трансляции. Раньше для него копировали отдельную ссылку с номером табло; теперь
 * панель находит его в шаблоне сама, потому что шаблон известен только после старта матча.
 */
function TvBoardControl(props: DivProps) {
  const { className = '', ...rest } = props;
  const { boards } = useBoards();
  const { activeTemplate } = useTemplates();

  const tvBoard = useMemo(() => boards.find((board) => board.type === 'tv'), [boards]);

  if (!tvBoard) {
    return (
      <PanelItemWrapper className={'flex flex-col gap-2 ' + className} {...rest}>
        <UDText type={'headline'} color={theme.colors.Gray}>
          Экран в зале (TV)
        </UDText>
        <UDText type={'subhead'} color={'white'}>
          В шаблоне «{activeTemplate?.name ?? 'без названия'}» нет табло с типом TV, поэтому запускать нечего.
        </UDText>
        <UDText type={'subhead'} color={'white'}>
          Откройте шаблон, добавьте табло и выберите у него тип «TV» — кнопка запуска появится здесь сама.
        </UDText>
        {activeTemplate && (
          <a
            href={Pages.TEMPLATE.builders.boards(activeTemplate.id)}
            target={'_blank'}
            rel={'noreferrer'}
            style={{ color: theme.colors.EditorAccentBlue }}
          >
            <UDText type={'subhead'} color={theme.colors.EditorAccentBlue}>
              Открыть шаблон «{activeTemplate.name}»
            </UDText>
          </a>
        )}
      </PanelItemWrapper>
    );
  }

  return (
    <PanelItemWrapper className={'flex flex-col gap-2 ' + className} {...rest}>
      <UDText type={'headline'} color={theme.colors.Gray}>
        Экран в зале (TV)
      </UDText>
      <UDText type={'subhead'} color={'white'}>
        Табло «{tvBoard.name}» откроется в отдельном окне: без джойстика и без смены табло из трансляции.
      </UDText>
      <PopupControl boardId={tvBoard.id} isLocked isHidePanel />
    </PanelItemWrapper>
  );
}

export default TvBoardControl;
